import { Y42RouterService } from '../routing/y42-router.service';
import { AbstractFeatureChildQueryEntity } from '../state/abstract-feature-child-query-entity.service';
import { AbstractFeatureAggregationService } from './abstract-feature-aggregation.service';
import { AbstractFeatureChildService } from './abstract-feature-child.service';

export abstract class FeatureChildAggregationService extends AbstractFeatureAggregationService<
  AbstractFeatureChildService,
  AbstractFeatureChildQueryEntity
> {
  constructor(protected readonly routerService: Y42RouterService) {
    super(routerService);
  }
}
